import { render, staticRenderFns } from "./BindUserInfoQrcode.vue?vue&type=template&id=08e3e545&scoped=true&"
import script from "./BindUserInfoQrcode.vue?vue&type=script&lang=js&"
export * from "./BindUserInfoQrcode.vue?vue&type=script&lang=js&"
import style0 from "./BindUserInfoQrcode.vue?vue&type=style&index=0&id=08e3e545&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e3e545",
  null
  
)

export default component.exports